// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2xMfi","modalForm":"UpgradeEpcsModal_modalForm__cynWD","modalFooter":"UpgradeEpcsModal_modalFooter__2wmT2"};